import axiosNest from '../../api/axiosNest';

/**
 * Statystyka cen z VIA (13.10.2026) — stan przeliczenia i ręczne
 * uruchomienie (`/price-statistics` w API, za przełącznikiem
 * `priceStatistics`). Liczby i progi trzyma API.
 */

export type PriceStatRun = {
  id: number;
  triggeredBy: string;
  triggeredByName: string | null;
  startedAt: string;
  finishedAt: string | null;
  examined: number;
  used: number;
  skipped: Record<string, number> | null;
  rows: number;
  error: string | null;
};

export type PriceStatisticsState = {
  enabled: boolean;
  hour: number;
  lastStartedAt: string | null;
  running: boolean;
  lastResult: string | null;
  errors: string[];
  minOrders: number;
  runs: PriceStatRun[];
};

/** Stan z API; pola bez właściwego kształtu — puste (starsze API, atrapa). */
export async function fetchPriceStatisticsState(): Promise<PriceStatisticsState> {
  const { data } = await axiosNest.get<Partial<PriceStatisticsState>>('/price-statistics');
  return {
    enabled: data?.enabled === true,
    hour: typeof data?.hour === 'number' ? data.hour : 0,
    lastStartedAt: typeof data?.lastStartedAt === 'string' ? data.lastStartedAt : null,
    running: data?.running === true,
    lastResult: typeof data?.lastResult === 'string' ? data.lastResult : null,
    errors: Array.isArray(data?.errors) ? data.errors : [],
    minOrders: typeof data?.minOrders === 'number' ? data.minOrders : 0,
    runs: Array.isArray(data?.runs) ? data.runs : [],
  };
}

/** Ręczne przeliczenie — sekcja administracyjna; drugie w trakcie = 409. */
export async function runPriceStatistics(): Promise<{ examined: number; used: number; rows: number }> {
  const { data } = await axiosNest.post('/price-statistics/run');
  return data;
}
